import BillingAddons from './BillingAddonsPage'
import BillingHistoryPage from './BillingHistoryPage'
import BillingPlansPage from './BillingPlansPage'

/**
 * billing routes
 */
export const billingRoutes = [
  {
    //path: 'account',
    name: 'Plans',
    index: true,
    component: BillingPlansPage,
  },
  {
    path: 'addons',
    name: 'Addons',
    component: BillingAddons,
  },
  {
    path: 'payment-history',
    name: 'Payment History',
    component: BillingHistoryPage,
    withoutPaymentSummary: true,
  },
  // {
  //   path: 'transactions/*',
  //   name: 'Transactions',
  //   component: BillingTransaction,
  //   showOnNav: false,
  // },
  // {
  //   path: 'payment-methods',
  //   name: 'Payment Methods',
  //   component: BillingPaymentMethods,
  // },
  // {
  //   path: 'addresses',
  //   name: 'Addresses',
  //   component: BillingAddresses,
  // },
]
